/**
 * Cron ↔ time-of-day helpers for the Digests settings UI.
 *
 * Digest schedules only ever need "what time" (daily) or "what time, always
 * Monday" (weekly per spec decision 5 — no day picker) so this module only
 * parses/builds the narrow 5-field shape `m H * * *` / `m H * * 1`, not
 * general cron.
 *
 * @module features/digests/cron
 */

import type { DigestKind } from '@chatsdet/types';

const CRON_RE = /^(\d{1,2}) (\d{1,2}) \* \* (\*|1)$/;

export interface CronTime {
  hour: number;
  minute: number;
}

/** Parse a `m H * * *` / `m H * * 1` cron string, or null if it doesn't match that shape. */
export function cronToTime(cron: string): CronTime | null {
  const match = CRON_RE.exec(cron.trim());
  if (!match) return null;
  const minute = Number(match[1]);
  const hour = Number(match[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return { hour, minute };
}

/** Build the cron string for a digest kind at a given time. Weekly is always Monday. */
export function timeToCron(kind: DigestKind, hour: number, minute: number): string {
  const dayOfWeek = kind === 'weekly' ? '1' : '*';
  return `${minute} ${hour} * * ${dayOfWeek}`;
}
